import { render, staticRenderFns } from "./CapexPage.vue?vue&type=template&id=9d22a54a"
import script from "./CapexPage.vue?vue&type=script&lang=ts"
export * from "./CapexPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports